export default __webpack_public_path__ + "37976327774d2285ab760aca5d2705b7.png";